export interface Tag {
    id: number;
    name: string;
}

export function TagFromJSON(json: any): Tag {
    return {
        id: json["id"],
        name: json["name"],
    }
}
